module.exports = __webpack_public_path__ + "static/media/121.378246b9.png";